<template>
    <div class="upload-file">
        <vue-dropzone id="dropzone" ref="dropzone" :options="dropzoneOptions"  v-on:vdropzone-queue-complete="afterComplete()"></vue-dropzone>
    </div>
</template>

<script>
    import vueDropzone from "vue2-dropzone";
    import eventHub from '../components/EventHub';

    export default {

        mounted() {
            // console.log('Upload mounted.')
        },

        components: {
            vueDropzone
        },

        props:['model_id','model_type'],

        data() {
            return {
                dropzoneOptions: {
                    url: '/admin/uploadSpatie',
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                    },
                    params: {'model_id': this.model_id, 'model_type': this.model_type },
                },
            }
        },

         methods: {
            // sendingEvent (file, xhr, formData) {
            //     formData.append('paramName', 'some value or other');
            // },

            afterComplete() {
                this.$refs.dropzone.removeAllFiles();
                eventHub.$emit('pictureAdded', 'true');
            },

            queueComplete(){
                console.log('queue complete');
                this.$refs.dropzone.removeAllFiles();
            }
        },

    }
</script>